<template>
    <q-table
        id="changeover-cause-table"
        :rows="report"
        :columns="table.columns"
        :pagination="pagination"
        :hide-bottom="report.length > 0"
        :table-class="{ 'sticky-table': report.length > 0 }"
        row-key="id"
        class="no-shadow border-grey"
        @update:pagination="updatePagination($event)"
        :no-data-label="
            $t('No planned downtime causes were found during this timeframe.')
        "
    >
        <template v-slot:header="props">
            <q-tr :props="props" v-if="report.length > 0">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ col.label }}
                    <q-tooltip style="font-size: 14px">
                        {{ tooltipText[col.name] }}
                    </q-tooltip>
                </q-th>
            </q-tr>
        </template>
        <template v-slot:body-cell-causeName="props">
            <q-td class="formatted-cell ellipsis">
                {{ props.row.causeName }}
            </q-td>
        </template>
    </q-table>
</template>

<script>
import { convertDurationToMinutes } from '@utils/time.js';

export default {
    name: 'ChangeoverCauseTable',
    emits: ['update:pagination'],
    props: {
        report: {
            type: Object,
            required: true
        },
        pagination: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            tooltipText: {
                causeName: this.$t('The changeover cause'),
                eventsCount: this.$t('The number of changeovers of this cause'),
                averageDuration: this.$t(
                    'The average duration for changeovers of this cause'
                ),
                totalAccumulatedExpectedDuration: this.$t(
                    'The total expected duration for all changeovers of this cause'
                ),
                totalAccumulatedDuration: this.$t(
                    'The total actual duration for all changeovers of this cause'
                ),
                totalLoss: this.$t(
                    'The difference between the total expected and total actual duration of all changeovers of this cause'
                ),
                averageLoss: this.$t(
                    'The total loss averaged over the number of changeovers of this cause'
                )
            }
        };
    },
    computed: {
        table() {
            return {
                columns: [
                    {
                        name: 'causeName',
                        field: 'causeName',
                        label: this.$t('Cause'),
                        align: 'left',
                        sortable: true
                    },
                    {
                        name: 'eventsCount',
                        field: 'eventsCount',
                        label: this.$t('Number of Events'),
                        align: 'left',
                        sortable: true
                    },
                    {
                        name: 'averageDuration',
                        field: 'averageDuration',
                        label: this.$t('Average Duration (min)'),
                        align: 'left',
                        sortable: true,
                        format: val => this.convertDurationToMinutes(val)
                    },
                    {
                        name: 'totalAccumulatedExpectedDuration',
                        field: 'totalAccumulatedExpectedDuration',
                        label: this.$t('Total Expected Duration (min)'),
                        align: 'left',
                        sortable: true,
                        format: val => this.convertDurationToMinutes(val)
                    },
                    {
                        name: 'totalAccumulatedDuration',
                        field: 'totalAccumulatedDuration',
                        label: this.$t('Total Accumulated Duration (min)'),
                        align: 'left',
                        sortable: true,
                        format: val => this.convertDurationToMinutes(val)
                    },
                    {
                        name: 'totalLoss',
                        field: 'totalLoss',
                        label: this.$t('Total Loss (min)'),
                        align: 'left',
                        sortable: true,
                        format: val => this.convertDurationToMinutes(val)
                    },
                    {
                        name: 'averageLoss',
                        field: 'averageLoss',
                        label: this.$t('Average Loss (min)'),
                        align: 'left',
                        sortable: true,
                        format: val => this.convertDurationToMinutes(val)
                    }
                ],
                pagination: {
                    rowsPerPage: 0 // infinite
                }
            };
        }
    },
    methods: {
        convertDurationToMinutes,
        /**
         * Emits an event to update the pagination state.
         * @param {Object} pagination - The new pagination data to be emitted.
         */
        updatePagination(pagination) {
            this.$emit('update:pagination', pagination);
        }
    }
};
</script>

<style lang="scss" scoped>
:deep(.q-table__top) {
    background-color: $secondary-white;
}
:deep(.formatted-cell) {
    min-width: 250px;
    max-width: 250px;
}
</style>
